import { styled as muiStyled, TableCell } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const CardLine = muiStyled(TableCell)({
  borderRadius: '4px',
  borderColor: NEW_COLORS.PRIMARY[50],
  borderWidth: '1px',
  borderStyle: 'solid',
});

export { CardLine };
